import config from '../../config';

export default {
  url: `${config.api
    .baseURL}/accounts/:accountId/profiles/:profileId/dischargeProgress`,
  options: {
    method: 'post'
  },
  transformer(data) {
    return data;
  }
};
